// extracted by mini-css-extract-plugin
export default {"admin_page":"AdminPage_admin_page__AUEb6","page_content_wrapper":"AdminPage_page_content_wrapper__ackYf","page_content":"AdminPage_page_content__Of-GD"};